import api from 'utils/api';

export const getListClass = async (data) => {
    const response = await api.get('/classes', { params: data });
    return response.data;
};

export const getListClassDropdown = async (params) => {
    const response = await api.get('/classes/dropdown', { params });
    return response.data;
};

export const updateClass = async (id, data) => {
    const response = await api.put(`/classes/${id}`, data);
    return response.data;
};

export const deleteClass = async (data) => {
    const response = await api.delete(`/classes`, { data: data });
    return response.data;
};

export const deleteClassMembers = async (id, data) => {
    const response = await api.delete(`/classes/${id}/members`, { data: data });
    return response.data;
};

export const addClass = async (data) => {
    const response = await api.post(`/classes`, data);
    return response.data;
};

export const uploadClasses = async (data) => {
    const response = await api.post('classes/import', data);
    return response.data;
};

export const uploadStudentsToClass = async (id, data) => {
    const response = await api.post(`classes/${id}/import`, data);
    return response.data;
};

export const addTeacherClass = async (id, data) => {
    const response = await api.post(`/classes/${id}/assign-teacher`, data);
    return response.data;
};

export const getClass = async (id) => {
    const response = await api.get(`/classes/${id}`);
    return response.data;
};
